import {
	Component,
	HostListener,
	OnInit,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
	ConstantsService,
	MISSION_TYPE_REUNION_TYPE,
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { User } from 'src/app/shared/models/security/user';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { FormationsModalAjoutFormComponent } from '../modal/formations-modal-ajout-form/formations-modal-ajout-form.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PaginatePipe } from 'ngx-pagination';
import { FilterFormationBySkillPipe } from 'src/app/shared/pipes/filterFormations/filter-formation-by-skill.pipe';
import { FilterFormationByAllFieldsPipe } from 'src/app/shared/pipes/filterFormations/filter-formation-by-all-fields.pipe';
import { Mission } from 'src/app/shared/models/mission/mission';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Authority } from 'src/app/shared/models/security/authority';
import { saveAs } from 'file-saver';
import { State } from 'src/app/shared/enums/state.enum';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { SerieModalAjoutFormComponent } from '../modal/serie-modal-ajout-form/serie-modal-ajout-form.component';
import { initial } from 'lodash';
import { CenterDepartment } from 'src/app/shared/models/center-department';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-formation',
	templateUrl: './list-formation.component.html',
	styleUrls: ['./list-formation.component.scss']
})
export class ListFormationComponent implements OnInit {
	/**
	 * Liste des formations à afficher
	 */
	formations: MissionRequest[];
	/**
	 * Liste des id des missions qui lui sont attachées, si l'utilisateur est un project manager
	 */
	projectManagerMissionRequestsIds: number[] = []; // liste d'ids des formations du projectManager

	/**
	 * Index de pagination
	 */
	currentPage = 0;

	/**
	 * Date du jour
	 */
	today: Date = new Date();

	/**
	 * Spécialité rechercher
	 */
	searchedSpeciality = '';

	/**
	 * Compétence rechercher
	 */
	searchedSkill = '';

	/**
	 * Import des formations
	 */
	formationsCsvFile: File = null;

	alerts: any[] = [];

	/**
	 * Modal d'ajout de formation
	 */
	@ViewChild('addFormationModal', { static: true })
	addFormationModal: TemplateRef<any>;

	/**
	 * step in minutes for the time-picker component
	 */
	minuteStep = 5;

	/**
	 * Date du jour
	 */
	date = new Date();

	/**
	 * Authoritée de l'utilisateur
	 */
	currentUserAuthority = Authority.INTERVENANT;

	/**
	 * Utilisateur
	 */
	user: User = null;

	/**
	 * Enum de compétence abrégée
	 */
	competences: CareSkill[];

	/**
	 * Enum de compétence
	 */
	competencesFull;

	/**
	 * Label pour les beneficiaires
	 */
	labelBeneficiaire: string;

	/**
	 * Label pour les intervention
	 */
	labelIntervention: string;

	/**
	 * Label pour les interventions au pluriel
	 */
	labelInterventionPluralized: string;

	/**
	 * Booleen relatif à si l'utilisateur est planificateur/trice
	 */
	isPlanif = false;

	/**
	 * Boolean relatif à si l'utilisateur est Charger de mission
	 */
	isProjectManager = false;

	/**
	 * Boolean relatif à si l'utilisateur est Professionnel SAE
	 */
	isProfessionnelSAE = false;

	/**
	 * Mode soin à domicile
	 */
	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;

	/**
	 * Booleen relatif à la possibilité pour l'utilisateur d'ajouter (ouvrir la modal) une missionRequest
	 */
	isAddable = false;

	/**
	 * Booleen relatif à la possibilité pour l'utilisateur d'importer un fichier csv avec des missionRequest
	 */
	isImportable = false;

	/**
	 * Booleen relatif à la possibilité pour l'utilisateur d'exporter un fichier avec la liste des missionRequest
	 */
	isExportable = false;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = 'date';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	/**
	 * Texte saisie dans la barre de recherche
	 */
	searchedText: string;

	/**
	 * Liste des compétences cochés dans le filtre
	 */
	selectedCompetences: string[] = [];

	/**
	 * Liste des compétences cochés dans le filtre concactener en 1 string
	 */
	selectedCompetencesDisplay: string;

	/**
	 * Plage de date sélectionner avec le selecteur de semaine ou dans le dateRangePicker du filtre
	 */
	dateRange: { value: Date[] } = { value: null };

	/**
	 * Numéro de semaine
	 */
	weeknumber: { value: number } = { value: null };

	/**
	 * Numéro d'année
	 */
	yearnumber: { value: number } = { value: null };

	/**
	 * Modal d'ajout de formation
	 */
	ajoutFormationModalref: BsModalRef;

	isBtnValidateDeleteListClicked = false;

	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];
	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	/**
	 * Nombre d'élément dans la pagination
	 */
	itemsPerPage = 10;

	/**
	 * Booleen servant à vérifier si l'on est en mode edition/suppression
	 */
	isEditionModeActive = false;

	/**
	 * Booleen relatif à si toutes les missions ont été coché pour la suppression
	 */
	allMissionChecked = false;

	/**
	 * Liste de formation à supprimer
	 */
	listSelectedMissionRequestDelete: MissionRequest[] = [];

	/**
	 * Modal de suppression multiple
	 */
	modalSuppressionMultipleRef?: BsModalRef;

	/**
	 * Template html de la modal de suppression multiple
	 */
	@ViewChild('modalSuppressionMultiple')
	suppressionMultipleTemplate: TemplateRef<any>;

	/**
	 * Modal de suppression si la mission relative à la missionRequest est dans un planning
	 */
	modalSuppressionAssignedToPlanningRef?: BsModalRef;

	/**
	 * Template html de la modal de suppression de mission affecter
	 */
	@ViewChild('modalSuppressionAssignedToPlanning')
	modalSuppressionAssignedToPlanningTemplate: TemplateRef<any>;

	/**
	 * Boolean indiquant si les missions affecter doivent être supprimer
	 */
	deleteMissionsAssignedToPlanning = false;

	/**
	 * Etat de la mission
	 */
	state = State;

	/**
	 * Nom du type de mission (Formation longue, Réunion, mission annexe, etc)
	 */
	missionTypeName = MissionTypeName;

	MISSION_TYPE_REUNION_TYPE = MISSION_TYPE_REUNION_TYPE;

	screenWidth: number;
	isMobile = false;
	valuesChecked = [];

	isListingLoading: boolean = true;

	centerDepartments: CenterDepartment[] = [];
	selectedDepartments: CenterDepartment[] = [];

	constructor(
		private constantsService: ConstantsService,
		protected utils: DateUtils,
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		private modalService: BsModalService,
		private route: ActivatedRoute,
		private filterFormationBySkillPipe: FilterFormationBySkillPipe,
		private filterFormationByAllFieldsPipe: FilterFormationByAllFieldsPipe,
		private paginatePipe: PaginatePipe
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelBeneficiaire = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_BENEFICIAIRE
		);
		this.labelInterventionPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		this.user = this.facade.dataStorageService.getUser();

		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();
		this.isProjectManager = this.facade.dataStorageService.isProjectManager();
		this.isProfessionnelSAE =
			this.facade.dataStorageService.isProfessionnelSAE();

		if (this.isPlanif || this.isProjectManager || this.isProfessionnelSAE) {
			this.isAddable = true;
			if (this.isPlanif) {
				this.isImportable = true;
				this.isExportable = true;
			}
		}

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();

		this.facade.careSkillService.getAllCareSkills().subscribe({
			next: (careSkills: CareSkill[]) => {
				this.competences = careSkills;
			},
			error: (err) => {
				this.logger.log(err);
			}
		});

		this.today.setHours(0, 0, 0, 0);

		this.route.data.subscribe((data) => {
			if (data.openModal) {
				this.openModalAjout(this.route.queryParams);
			}
		});
	}

	getTypeAndCareSkill(missionRequest: MissionRequest) {
		const type = missionRequest?.missionType?.type;
		const careSkills = this.isSAAD
			? ''
			: missionRequest.careSkills
					.map((c) => c.name.replaceAll('_', ' '))
					.join(' | ');
		const stringToReturn = type + (careSkills !== '' ? ` (${careSkills})` : '');
		return stringToReturn;
	}

	/**
	 * Appel au back pour récupérer les missionRequest dans l'intervalle de temps donner
	 * @param date1
	 * @param date2
	 */
	getFormations(date1: Date, date2: Date) {
		this.isListingLoading = true;
		this.facade.formationService.getFormations(date1, date2).subscribe(
			(val) => {
				this.formations = val;
				this.currentPage = 1;
				this.itemsPerPage = this.formations.length >= 5 ? 10 : 5;
				this.allMissionChecked = false;
				this.listSelectedMissionRequestDelete = [];

				this.extractCenterDepartments();

				/**
				 * Dans le cas du project manager, l'on va récupérer les mission(Request) qui lui sont associer sur la plage selectionner,
				 * cela servira à empêcher le project manager d'editer d'autre missionRequest
				 */
				if (this.isProjectManager || this.isProfessionnelSAE) {
					this.facade.missionService
						.getAllMissionsOfProjectManagerByDateformationBetween(
							date1,
							date2,
							this.user.employee.id,
							this.user.employee.serviceCenter.id
						)
						.subscribe({
							next: (missions: Mission[]) => {
								this.projectManagerMissionRequestsIds = missions.map(
									(mission) => mission.missionRequest.id
								);
							},
							error: (err) => {
								this.logger.log(err);
							}
						});
				}

				this.isListingLoading = false;
			},
			(err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
			}
		);
	}

	extractCenterDepartments() {
		this.centerDepartments = this.formations
			.map((formation) => formation.centerDepartment)
			.filter((cd) => cd) // exclut les centerDepartments null / undefined
			.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
			.sort((a, b) => a.name.localeCompare(b.name));
	}

	changeDepartmentFilter(values: any, department: CenterDepartment): void {
		// Add
		if (values.currentTarget.checked) {
			const clone = [...this.selectedDepartments];
			clone.push(department);
			this.selectedDepartments = clone;
		} else {
			// Remove
			this.selectedDepartments = this.selectedDepartments.filter(
				(e) => e !== department
			);
		}
	}

	/**
	 * Renvoi vrai ou faux selon si l'id de la missionRequest ce trouve dans la liste des id de missionRequest du projet manager
	 * @param idFormation
	 * @returns
	 */
	isFormationIdInProjectManagerArray(idFormation: number): boolean {
		return this.projectManagerMissionRequestsIds.includes(idFormation);
	}

	isAssignedMissionRequestMutable(missionRequest: MissionRequest) {
		return !missionRequest.assignedToPlanning;
	}

	canMissionBeChecked(missionRequest: MissionRequest) {
		const canMissionBeChecked =
			((this.isProjectManager || this.isProfessionnelSAE) &&
				!this.isFormationIdInProjectManagerArray(missionRequest.id)) ||
			!this.isAssignedMissionRequestMutable(missionRequest);

		if (this.state[missionRequest.state].includes(this.state.CANCELED)) {
			return true;
		}

		return canMissionBeChecked;
	}

	/**
	 * Import des missionRequest
	 * @param event
	 */
	importFormations(event: any) {
		this.isImportable = false;
		this.alerts = [];
		this.logger.log('Import de la formation');
		this.formationsCsvFile = event.target.files[0];

		this.facade.formationService
			.importFormations(this.formationsCsvFile)
			.subscribe({
				next: (resp: ImportResponse) => {
					this.isImportable = true;
					const nbDatesOk = 'entitiesAdded';
					const nbForAlreadyInDb = 'entitiesBeforeImport';
					if (resp[nbDatesOk] && resp[nbDatesOk] === 0) {
						this.facade.toastService.createWarningToast(
							`Aucun import réalisé : ${nbDatesOk} : ${resp[nbDatesOk]}. ${nbForAlreadyInDb} : ${resp[nbForAlreadyInDb]}`
						);
					} else {
						this.today = new Date();
						this.today.setHours(0, 0, 0, 0);
						const searchedDate: Date = this.utils.getMonday(this.today);
						const secondSearchedDate: Date = new Date();
						secondSearchedDate.setDate(searchedDate.getDate() + 6);

						this.dateRange.value = [searchedDate, secondSearchedDate];
						this.getFormations(
							this.dateRange.value[0],
							this.dateRange.value[1]
						);
						this.reload();
						this.facade.toastService.createSuccessToast('Import effectué');
					}
					this.logger.log("C'est importé !");
				},
				error: (err: ErrorResponse) => {
					this.isImportable = true;
					this.logger.log("C'est PAS importé !", err.error.response);
					this.logger.log('' + err);

					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	/**
	 * Export des missionRequest
	 */
	exportFormations(): void {
		const year: number = this.dateRange.value[0].getFullYear();
		const weekNumber: number = this.utils.getWeekNumber(
			this.dateRange.value[0]
		);
		this.facade.exportService
			.exportFormations(year, weekNumber)
			.subscribe((blob) => saveAs(blob, 'formations.csv'));
	}

	handleAddEvent(event: MouseEvent) {
		const target = event.target as HTMLElement;
		const option = target.innerText;

		switch (option) {
			case 'Prestation':
				this.openModalAjout();
				break;
			case 'Série de prestations':
				this.openModalAjoutSerie();
				break;
			default:
				this.openModalAjout();
				break;
		}
	}

	openModalAjoutSerie(queryParams?: Params) {
		let initialState = {};
		if (queryParams) {
			queryParams.subscribe((params) => {
				initialState = {
					parameters: {
						date: params['date'],
						startTime: params['startTime'],
						endTime: params['endTime'],
						missionType: params['missionType'],
						skill: params['skill'],
						id: params['id'],
						specialty: params['specialty'],
						beneficiaireId: params['beneficiaireId']
					}
				};

				this.ajoutFormationModalref = this.modalService.show(
					SerieModalAjoutFormComponent,
					{
						class: 'modal-lg',
						initialState,
						backdrop: 'static'
					}
				);
			});
		} else {
			this.ajoutFormationModalref = this.modalService.show(
				SerieModalAjoutFormComponent,
				{
					class: 'modal-lg',
					initialState,
					backdrop: 'static'
				}
			);
		}

		this.ajoutFormationModalref.onHide.subscribe((reason: string | any) => {
			this.getFormations(this.dateRange.value[0], this.dateRange.value[1]);
		});
	}

	/**
	 * Ouvre la modal d'ajout en utilisant le composant FormationsModalAjoutFormComponent
	 */
	openModalAjout(queryParams?: Params) {
		let initialState = {};
		if (queryParams) {
			queryParams.subscribe((params) => {
				let initialState = {};

				if (params['date']) {
					initialState = {
						parameters: {
							date: params['date'],
							startTime: params['startTime'],
							endTime: params['endTime'],
							missionType: params['missionType'],
							skill: params['skill'],
							id: params['id'],
							specialty: params['specialty'],
							beneficiaireId: params['beneficiaireId']
						}
					};

					this.ajoutFormationModalref = this.modalService.show(
						FormationsModalAjoutFormComponent,
						{
							class: 'modal-lg',
							initialState,
							backdrop: 'static'
						}
					);
				} else if (params['start']) {
					initialState = {
						parameters: {
							start: params['start'],
							end: params['end'],
							hours: params['hours'],
							prestationCount: params['prestationCount'],
							missionType: params['missionType'],
							// skill: params['skill'],
							// id: params['id'],
							// specialty: params['specialty'],
							beneficiaireId: params['beneficiaireId']
						}
					};

					this.ajoutFormationModalref = this.modalService.show(
						SerieModalAjoutFormComponent,
						{
							class: 'modal-lg',
							initialState,
							backdrop: 'static'
						}
					);
				}
			});
		} else {
			this.ajoutFormationModalref = this.modalService.show(
				FormationsModalAjoutFormComponent,
				{
					class: 'modal-lg',
					initialState,
					backdrop: 'static'
				}
			);
		}

		this.ajoutFormationModalref.onHide.subscribe((reason: string | any) => {
			this.getFormations(this.dateRange.value[0], this.dateRange.value[1]);
		});
	}

	/**
	 * Recharge la page
	 */
	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	/**
	 * Méthode de changement de tri
	 * @param str
	 */
	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	/**
	 * Change les compétences sélectionner dans les filtres
	 * @param values
	 * @param competence
	 */
	changeCompetencesFilter(values: any, competence: string): void {
		this.listSelectedMissionRequestDelete = [];
		this.allMissionChecked = false;

		// Add
		if (values.currentTarget.checked) {
			// Si la compétence est sélectionné
			if (competence === 'Sans' || this.selectedCompetences.includes('Sans')) {
				// Toutes les autres compétences sont déselectionnées
				let inputsToUnSelect = document.querySelectorAll(
					"[id^='dd']"
				) as NodeListOf<HTMLInputElement>;
				inputsToUnSelect.forEach((element) => {
					element.checked = false;
				});
				values.currentTarget.checked = true;

				const clone = [...this.selectedCompetences];
				clone.splice(0, clone.length);
				clone.push(competence);
				this.selectedCompetences = clone;
			} else {
				this.valuesChecked.push(values);
				const clone = [...this.selectedCompetences];
				clone.push(competence);
				this.selectedCompetences = clone;
			}
		} else {
			// Remove
			this.selectedCompetences = this.selectedCompetences.filter(
				(e) => e !== competence
			);
		}
		this.selectedCompetencesDisplay = this.selectedCompetences.sort().join();
	}

	/**
	 * Sélection d'une nouvelle date dans le dateRangePicker du filtre
	 */
	selectNewDate() {
		this.weeknumber.value = this.utils.getWeekNumber(this.dateRange.value[0]);
		this.yearnumber.value = this.dateRange.value[0].getFullYear();
		this.getFormations(this.dateRange.value[0], this.dateRange.value[1]);
		this.facade.dataStorageService.setParam(
			'storedCalendarWeeknumber',
			this.utils.getWeekNumber(this.dateRange.value[0])
		);
		this.storeDateRangeInSession();
	}

	/**
	 * Fonction appeler par le sélecteur de date
	 */
	dateRangeChange() {
		this.getFormations(this.dateRange.value[0], this.dateRange.value[1]);
	}

	storeDateRangeInSession() {
		this.facade.dataStorageService.setParam(
			'missionStartDate',
			this.dateRange.value[0]
		);
		this.facade.dataStorageService.setParam(
			'missionEndDate',
			this.dateRange.value[1]
		);
	}

	/**
	 * Ouvre la modal de suppression si des éléments sont selectionner et si l'utilisateur à un rôle autorisant la suppression (planificatrice ou project manager)
	 */
	deleteMultiple() {
		if (
			Array.isArray(this.listSelectedMissionRequestDelete) &&
			this.listSelectedMissionRequestDelete.length >= 1 &&
			(this.isAddable || this.isPlanif || this.isProjectManager)
		) {
			this.modalSuppressionMultipleRef = this.modalService.show(
				this.suppressionMultipleTemplate,
				{
					class: 'modal-lg'
				}
			);
		}
	}

	searchedTextChange() {
		this.listSelectedMissionRequestDelete = [];
		this.allMissionChecked = false;
	}

	/**
	 * Selectionne toutes les missions disponibles à la suppression
	 * @param event
	 */
	selectAllMissionForDelete(event: any) {
		if (event.currentTarget.checked) {
			this.allMissionChecked = true;

			//On applique les mêmes filtres que dans le html

			this.listSelectedMissionRequestDelete =
				this.filterFormationByAllFieldsPipe.transform(
					this.formations,
					this.searchedText
				) as MissionRequest[];
			this.listSelectedMissionRequestDelete =
				this.filterFormationBySkillPipe.transform(
					this.listSelectedMissionRequestDelete,
					this.selectedCompetences
				) as MissionRequest[];
			this.listSelectedMissionRequestDelete = this.paginatePipe.transform(
				this.listSelectedMissionRequestDelete,
				{
					itemsPerPage: this.itemsPerPage,
					currentPage: this.currentPage
				}
			);
			if (this.isProjectManager || this.isProfessionnelSAE) {
				this.listSelectedMissionRequestDelete =
					this.listSelectedMissionRequestDelete.filter((missionRequest) =>
						this.isFormationIdInProjectManagerArray(missionRequest.id)
					);
			}

			this.listSelectedMissionRequestDelete =
				this.listSelectedMissionRequestDelete.filter((missionRequest) => {
					return (
						!missionRequest.assignedToPlanning &&
						!this.state[missionRequest.state].includes(this.state.CANCELED)
					);
				});
			//Filtre les missions annuler, en cours, etc
			// this.listSelectedMissionRequestDelete =
			// 	this.listSelectedMissionRequestDelete.filter(
			// 		(missionRequest) =>
			// 			State[missionRequest.state] === this.state.UNDER_REVIEW
			// 	);
		} else {
			this.allMissionChecked = false;
			this.listSelectedMissionRequestDelete = [];
		}
	}

	/**
	 * Appeler lorsque l'on coche une checkbox d'une missionRequest pour la suppression.
	 * @param event
	 * @param mission
	 */
	selectMissionForDelete(event: any, mission: MissionRequest) {
		if (event.currentTarget.checked) {
			if (
				!mission.assignedToPlanning &&
				State[mission.state] === this.state.UNDER_REVIEW
			) {
				const clone = [...this.listSelectedMissionRequestDelete];
				clone.push(mission);
				this.listSelectedMissionRequestDelete = clone;
			}
		} else {
			this.allMissionChecked = false;
			this.listSelectedMissionRequestDelete =
				this.listSelectedMissionRequestDelete.filter(
					(e) => e.id !== mission.id
				);
		}
	}

	/**
	 * Retourne vrai si la missionRequest est dans la liste des mission à supprimer
	 * @param mission
	 * @returns
	 */
	isMissionCheckForDelete(mission: MissionRequest) {
		return this.listSelectedMissionRequestDelete.find(
			(m) => m.id === mission.id
		)
			? true
			: false;
	}

	/**
	 * Ouvre la modal de comfirmation de supression de missionRequest si l'une des missionRequest est assignée au plannig
	 */
	validateDeleteListSelectedMission() {
		this.deleteMissionsAssignedToPlanning = false;
		if (
			this.listSelectedMissionRequestDelete.some((m) => m.assignedToPlanning)
		) {
			//Si l'on a une mission affecter, ouvre une modal de confirmation
			this.modalSuppressionAssignedToPlanningRef = this.modalService.show(
				this.modalSuppressionAssignedToPlanningTemplate,
				{
					class: 'modal-lg'
				}
			);
			this.modalSuppressionAssignedToPlanningRef?.onHide.subscribe(() =>
				this.deleteListSelectedMission()
			);
		} else {
			this.deleteListSelectedMission();
		}
	}

	/**
	 * Appel au back pour supprimer les missionRequest
	 */
	deleteListSelectedMission() {
		this.isBtnValidateDeleteListClicked = true;

		if (!this.deleteMissionsAssignedToPlanning) {
			//On filtre la liste si les missions affecter ne doivent pas être supprimer
			this.listSelectedMissionRequestDelete =
				this.listSelectedMissionRequestDelete.filter(
					(e) => !e.assignedToPlanning
				);
		}

		this.facade.formationService
			.deleteFormations(this.listSelectedMissionRequestDelete)
			.subscribe({
				next: (succ) => {
					this.isBtnValidateDeleteListClicked = false;

					this.modalSuppressionMultipleRef.hide();
					this.isEditionModeActive = false;
					this.listSelectedMissionRequestDelete = [];
					this.getFormations(this.dateRange.value[0], this.dateRange.value[1]);
				},
				error: (err) => {
					this.isBtnValidateDeleteListClicked = false;
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
				}
			});
	}
}
